/**
 * The team's process, in the order it happens. Fixed on the server too - this
 * is a mirror for labelling and grouping, not a second source of truth.
 */
export const LIFECYCLE_PHASES = [
  { value: 'SiteSetup', label: 'Site Setup' },
  { value: 'PreEventPrep', label: 'Pre-Event Prep' },
  { value: 'ShippingOut', label: 'Shipping Out' },
  { value: 'OnsiteSetup', label: 'Onsite Setup' },
  { value: 'BadgePrinting', label: 'Badge Printing' },
  { value: 'EventScanning', label: 'Event and Session Scanning' },
  { value: 'Teardown', label: 'Teardown' },
  { value: 'ReturnShipping', label: 'Return Shipping' },
] as const

export type LifecyclePhase = (typeof LIFECYCLE_PHASES)[number]['value']

export const MILESTONE_ANCHORS = [
  { value: 'EventStart', label: 'Event start' },
  { value: 'EventEnd', label: 'Event end' },
] as const

export type MilestoneAnchor = (typeof MILESTONE_ANCHORS)[number]['value']

/**
 * Who is expected to do a piece of work. Fixed on the server too - this is a
 * mirror for the pickers, not a second source of truth, exactly like the
 * phases above.
 *
 * A label, never a permission: naming a role here grants nobody anything, and
 * no authorization decision consults it.
 *
 * Kept in the order the server offers them - CRI's own roles first, then the
 * outside parties, because the internal ones are picked far more often.
 */
export const OWNER_ROLES = [
  'CRI Account Manager',
  'CRI Dev',
  'CRI Onsite Lead',
  'Client',
  'Exhibitor',
] as const

export type OwnerRole = (typeof OWNER_ROLES)[number]
